import * as React from "react";
import {InsightsLoading} from "../../insights/kit/insightsLoading";
import {InsightsCard} from "../../insights/kit/InsightsCard";

const DEFAULT_SKELETON_HEIGHT = 56;

interface Props {
    title: string;
    hint?: string;
    loading?: InsightsLoading;
    skeletonHeight?: number;
    children: React.ReactNode;
}

/** Lightweight wrapper around InsightsCard for single-purpose cards without a fixed headline or footer. */
export function GenericInsightsCard({
    title,
    hint,
    loading,
    skeletonHeight = DEFAULT_SKELETON_HEIGHT,
    children,
}: Props) {
    return (
        <InsightsCard
            title={title}
            hint={hint}
            loading={loading}
            skeletonHeight={skeletonHeight}
            bodySx={{flex: 1, minHeight: 0, display: "flex", flexDirection: "column"}}
        >
            {children}
        </InsightsCard>
    );
}

